__webpack_require__.p = "https://qa.minerva26.com/packs/";